<template>
  <div>
    <vuex-breadcrumb></vuex-breadcrumb>
    <h1 id="jump-to-header">{{heading || "View"}}</h1>
    <actor-role-show :id="id"></actor-role-show>
  </div>
</template>

<script>
import VuexBreadcrumb from './VuexBreadcrumb.vue'
import ActorRoleShow from './ActorRoleShow.vue'

export default {
  components: {
    VuexBreadcrumb,
    ActorRoleShow
  },
  props: {
    id: String,
    heading: {
      Type: String
    }
  },
  mounted() {
    const element = document.getElementById("jump-to-header")
    element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
  }
}
</script>